import { render } from "./payslip.vue?vue&type=template&id=14014d4d&scoped=true"
import script from "./payslip.vue?vue&type=script&lang=js"
export * from "./payslip.vue?vue&type=script&lang=js"

import "./payslip.vue?vue&type=style&index=0&id=14014d4d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14014d4d"]])

export default __exports__